// Lightweight i18n for NGX Academy chrome (UI labels). English is the default.
export const LANGS = [
  { code: "de", label: "Deutsch" },
  { code: "en", label: "English" },
  { code: "pt", label: "Português" },
];

const STRINGS = {
  en: {
    academyTitle: "NGX Academy",
    academySubtitle: "Learn the technologies behind Human-in-the-Loop industrial systems.",
    learningProgress: "Learning Progress",
    complete: "Complete",
    overall: "Overall",
    learningPaths: "Learning Paths",
    lessons: "lessons",
    glossary: "Glossary",
    glossarySubtitle: "NGX technical terms in plain language.",
    searchTerms: "Search terms…",
    learn: "Learn",
    learningObjective: "Learning Objective",
    simpleExplanation: "Simple Explanation",
    technicalExplanation: "Technical Explanation",
    industrialExample: "Industrial Example",
    howItRelates: "How It Relates to NGX",
    tryIt: "Try It",
    knowledgeCheck: "Knowledge Check",
    keyTakeaways: "Key Takeaways",
    submitAnswers: "Submit Answers",
    yourScore: "Your score",
    markComplete: "Mark as Complete",
    completed: "Completed",
    backToAcademy: "Back to Academy",
    next: "Next",
    previous: "Previous",
    language: "Language",
    level: "Level",
    tag_MVP: "Current MVP",
    tag_FUTURE: "Future Integration",
    tag_CONCEPT: "Concept / Research",
    correct: "Correct",
    incorrect: "Incorrect",
    retake: "Retake",
    learningEnv: "Learning Environment",
  },
  de: {
    academyTitle: "NGX Academy",
    academySubtitle: "Lernen Sie die Technologien hinter Human-in-the-Loop-Industriesystemen.",
    learningProgress: "Lernfortschritt",
    complete: "Abgeschlossen",
    overall: "Gesamt",
    learningPaths: "Lernpfade",
    lessons: "Lektionen",
    glossary: "Glossar",
    glossarySubtitle: "NGX-Fachbegriffe einfach erklärt.",
    searchTerms: "Begriffe suchen…",
    learn: "Lernen",
    learningObjective: "Lernziel",
    simpleExplanation: "Einfache Erklärung",
    technicalExplanation: "Technische Erklärung",
    industrialExample: "Industriebeispiel",
    howItRelates: "Bezug zu NGX",
    tryIt: "Ausprobieren",
    knowledgeCheck: "Wissenscheck",
    keyTakeaways: "Kernpunkte",
    submitAnswers: "Antworten absenden",
    yourScore: "Ihr Ergebnis",
    markComplete: "Als abgeschlossen markieren",
    completed: "Abgeschlossen",
    backToAcademy: "Zurück zur Academy",
    next: "Weiter",
    previous: "Zurück",
    language: "Sprache",
    level: "Stufe",
    tag_MVP: "Aktuelles MVP",
    tag_FUTURE: "Zukünftige Integration",
    tag_CONCEPT: "Konzept / Forschung",
    correct: "Richtig",
    incorrect: "Falsch",
    retake: "Wiederholen",
    learningEnv: "Lernumgebung",
  },
  pt: {
    academyTitle: "NGX Academy",
    academySubtitle: "Aprenda as tecnologias por trás dos sistemas industriais Human-in-the-Loop.",
    learningProgress: "Progresso de Aprendizagem",
    complete: "Concluído",
    overall: "Geral",
    learningPaths: "Trilhas de Aprendizagem",
    lessons: "lições",
    glossary: "Glossário",
    glossarySubtitle: "Termos técnicos do NGX em linguagem simples.",
    searchTerms: "Buscar termos…",
    learn: "Aprender",
    learningObjective: "Objetivo de Aprendizagem",
    simpleExplanation: "Explicação Simples",
    technicalExplanation: "Explicação Técnica",
    industrialExample: "Exemplo Industrial",
    howItRelates: "Relação com o NGX",
    tryIt: "Experimente",
    knowledgeCheck: "Verificação de Conhecimento",
    keyTakeaways: "Pontos-Chave",
    submitAnswers: "Enviar Respostas",
    yourScore: "Sua pontuação",
    markComplete: "Marcar como Concluído",
    completed: "Concluído",
    backToAcademy: "Voltar à Academy",
    next: "Próximo",
    previous: "Anterior",
    language: "Idioma",
    level: "Nível",
    tag_MVP: "MVP Atual",
    tag_FUTURE: "Integração Futura",
    tag_CONCEPT: "Conceito / Pesquisa",
    correct: "Correto",
    incorrect: "Incorreto",
    retake: "Refazer",
    learningEnv: "Ambiente de Aprendizagem",
  },
};

export function getLang() {
  return localStorage.getItem("ngx_lang") || "de";
}
export function setLang(code) {
  localStorage.setItem("ngx_lang", code);
}
export function makeT(lang) {
  const dict = STRINGS[lang] || STRINGS.en;
  return (key) => dict[key] ?? STRINGS.en[key] ?? key;
}
